import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RemoteSourceUpdatePayload } from 'api/actions/remote-source-update/remote-source-update-payload';
import { RemoteSourceUpdatePathParameters } from 'api/actions/remote-source-update/remote-source-update-path-parameters';
import { RemoteSourceUpdateResponse } from 'api/actions/remote-source-update/remote-source-update-response';

type RemoteSourceUpdateQueryParameters = Record<string, any>;

/**
 * The path of the RemoteSourceUpdate action.
 */
export const remoteSourceUpdateActionPath = new SweetPath<keyof RemoteSourceUpdatePathParameters>(
  '/api/remote-source/update/{remoteSourceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RemoteSourceUpdate actions.
 */
export default function createRemoteSourceUpdateAction(axios: AxiosInstance) {
  return function remoteSourceUpdateAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RemoteSourceUpdatePathParameters;
    query?: RemoteSourceUpdateQueryParameters;
    payload: RemoteSourceUpdatePayload;
  }) {
    const path = remoteSourceUpdateActionPath.insert(parameters);

    return axios.request<RemoteSourceUpdateResponse, RemoteSourceUpdateResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
